import { reduxSetter } from '../../../../../utils/reduxSetter';
import { GET_LEADS_DIVISIONS_SUCCESS, GET_LEADS_DIVISIONS_FAILURE } from '../constants/get_leads_divisions.constants';
import {
    GET_LEADS_LEAD_MANAGE_SUCCESS,
    GET_LEADS_LEAD_MANAGE_FAILURE,
    COUNT_LEADS_SUCCESS,
    COUNT_LEADS_FAILURE,
    SET_LEAD_MANAGE_LOADING,
    SET_LEAD_MANAGE_KEY,
    UPDATE_LEAD_MANAGE_KEY,
    SET_LEAD_MANAGE_PAGINATION,
    SET_LEAD_MANAGE_NEW_KEY_VALUE, TOGGLE_SHOW_LEADS_ADDITIONAL_FILTERS,
} from '../constants/get_leads.constants';
import { GET_USERS_LIST, GET_USERS_LIST_FAILURE, GET_USERS_LIST_SUCCESS } from '../constants/get_users_list.constants';
import { GET_LEADS_AFFILIATE_SUCCESS, GET_LEADS_AFFILIATE_FAILURE } from '../constants/get_leads_affiliate.constants';
import {
    LEAD_MANAGE_GET_LEADS_STATUS_FAILURE,
    LEAD_MANAGE_GET_LEADS_STATUS_SUCCESS,
} from '../constants/lead_manage_leads_status.constants';
import { GET_COUNTY_LIST_SUCCESS } from '../constants/get_county_list.constants';
import {
    setVal, extend, each, get, is,
} from '../../../../../shared/helpers';
import { INITIAL_FILTERS_LEAD_MANAGE, INITIAL_PAGINATION_LEAD_MANAGE } from '../../contants/filter.constants';

const initialState = {
    leads: null,
    loading: false,
    leadsCount: 0,
    leadsStatus: null,
    modal_data: {
        users: {
            data: null,
            fetching_users: false,
            error: null,
        },
    },
    divisions: null,
    countyList: [],
    pagination: { ...INITIAL_PAGINATION_LEAD_MANAGE },
    /*
    possible values:
    0 - All leads,
    1 - assigned to me
    2 - part exchange
    3 - hot list
    lead manage active tab, by default 1
     */
    active_lead_manage_tab: 0,
    isShownAdditionalFilters: false,
    filters: { ...INITIAL_FILTERS_LEAD_MANAGE },
    where: {},
};

export const Leads_manage = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_MANAGE_DATA':
        return reduxSetter(state, action);
    case 'LEAD_MANAGE_RESET_FILTERS':
        return reduxSetter(state, {
            payload: {
                filters: { ...INITIAL_FILTERS_LEAD_MANAGE },
                pagination: { ...INITIAL_PAGINATION_LEAD_MANAGE },
                active_lead_manage_tab: 0,
            },
        });
    case TOGGLE_SHOW_LEADS_ADDITIONAL_FILTERS:
        return {
            ...state,
            isShownAdditionalFilters: !state.isShownAdditionalFilters,
        };
    case 'RESET_LEADS':
        return {
            ...state,
            loading: false,
        };
    case SET_LEAD_MANAGE_LOADING:
        setVal(state, 'loading', action.loading);
        return extend({}, state);

    case UPDATE_LEAD_MANAGE_KEY:
        return extend(true, {}, state, action.data);

    case SET_LEAD_MANAGE_NEW_KEY_VALUE:
        let state_changed = false;

        if (is.plainObject(action.data)) {
            each(action.data, (path, value) => {
                if (get(state, path) !== value) {
                    state_changed = true;
                    setVal(state, path, value);
                }
            });
            // return utils.extend( {}, state );
        } else if (is.string(action.path)) {
            if (get(state, action.path) !== action.value) {
                state_changed = true;
                setVal(state, action.path, action.value);
            }
            // return utils.extend( {}, state );
        }

        return state_changed ? { ...state } : state;


    case SET_LEAD_MANAGE_KEY:
        // eslint-disable-next-line no-restricted-globals
        const filterValue = (action.value === '' || action.value === undefined || (typeof action.value === 'number' && isNaN(action.value))) ? undefined : action.value;

        if (action.path && typeof filterValue === 'object' && !Array.isArray(filterValue)) {
            Object.keys(action.value)
                .forEach((key) => {
                    setVal(state, `${action.path}.${key}`, action.value[key]);
                });
        } else {
            setVal(state, action.path, filterValue);
        }
        return extend({}, { ...state, filters: { ...state.filters } });

    case SET_LEAD_MANAGE_PAGINATION:
        return reduxSetter(state, action);

    case GET_LEADS_LEAD_MANAGE_SUCCESS:
        return {
            ...state,
            leads: action.leads,
        };


    case GET_LEADS_LEAD_MANAGE_FAILURE:
        return {
            ...state,
            error: action.error,
            leads: [],
            leadsCount: 0,
        };
        //-----------------------------------------------------------------------------


    case COUNT_LEADS_SUCCESS:
        return {
            ...state,
            leadsCount: action.leadsCount,
        };
    case COUNT_LEADS_FAILURE:
        return {
            ...state,
            error: action.error,
            leadsCount: 0,
        };

    case GET_LEADS_DIVISIONS_SUCCESS:
        return {
            ...state,
            divisions: action.leadsDivisions,
        };

    case GET_LEADS_AFFILIATE_SUCCESS:
        return {
            ...state,
            affiliate: action.leadsAffiliate,
        };

    case GET_USERS_LIST:
        setVal(state, 'modal_data.users.fetching_users', true);
        return extend({}, state);

    case GET_USERS_LIST_SUCCESS:
        setVal(state, 'modal_data.users', { data: action.payload, fetching_users: false });
        return state;

    case GET_USERS_LIST_FAILURE:
        setVal(state, 'modal_data.users', { error: action.error, fetching_users: false });
        return state;

    case LEAD_MANAGE_GET_LEADS_STATUS_SUCCESS:
        return {
            ...state,
            leadsStatus: action.leadsStatus,
        };

    case LEAD_MANAGE_GET_LEADS_STATUS_FAILURE:
        return {
            ...state,
            leadsStatus: [],
            error: action.error,
        };

    case GET_COUNTY_LIST_SUCCESS:
        return {
            ...state,
            countyList: action.payload,
        };

    case GET_LEADS_DIVISIONS_FAILURE:
    case GET_LEADS_AFFILIATE_FAILURE:
        return {
            ...state,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/reducers/leads_manage.reducer.js